/** 重要提醒 */

import request from '@/utils/request'

export default {
  /** 查询重要提醒 栏目 */
  queryPormptColumn(data) {
    return request({
      method: 'post',
      url: '/prompt/getPromptExpireColumn',
      data
    })
  },
  /** 查询重要提醒 栏目信息 */
  queryPormptColumnInfo(data) {
    return request({
      method: 'post',
      url: '/prompt/getPromptConfiguration',
      data
    })
  },
  //
  // 获取邮件数量
  getTxUnMail() {
    return request({
      method: 'post',
      url: '/prompt/getTxUnMail',
    })
  },

  // 获取待办事项数量
  countMessageInfo() {
    return request({
      method: 'post',
      url: '/workbench/countMessageInfo',
    })
  }
}